import LegalShell from "@/components/LegalShell";

export default function PrivacyPolicy() {
  return (
    <LegalShell
      title="Privacy Policy"
      subtitle="How we handle the personal data you share with us."
      testId="privacy-policy-page"
    >
      <p>
        <strong className="text-navy">Data controller:</strong> Salihi Group, headquartered in Mogadishu,
        Somalia. For any privacy matter, contact{" "}
        <a className="text-gold hover:underline" href="mailto:info@salihigroup.com">info@salihigroup.com</a>.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">1. What we collect</h2>
      <p>
        When you submit our contact form we collect the information you provide — your name, email address,
        phone number, company name (if provided), subject, and message. We also automatically collect basic
        technical data (IP address, browser type, pages viewed) for security and analytics.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">2. Purpose</h2>
      <p>
        We use this information to respond to your enquiry, provide our professional services, maintain the
        security of the site, and — with your consent — to improve the site through analytics.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">3. Legal basis</h2>
      <p>
        We process personal data on the basis of your consent (via the cookie banner and contact form
        submission) and our legitimate interest in operating a professional website.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">4. Retention</h2>
      <p>
        Contact submissions are retained for up to 24 months for follow-up and record-keeping. Analytics data
        is retained in aggregated form.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">5. Sharing</h2>
      <p>
        We do not sell personal data. We share personal data only with (a) service providers strictly
        necessary to operate this site and (b) where required by law.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">6. Your rights</h2>
      <p>
        You have the right to access, correct, or request deletion of your personal data. Send any request
        to <a className="text-gold hover:underline" href="mailto:info@salihigroup.com">info@salihigroup.com</a>{" "}
        and we will respond within a reasonable time frame.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">7. Security</h2>
      <p>
        We apply reasonable technical and organisational measures to protect personal data — including
        transport encryption (HTTPS) and access controls on our systems. No system is perfectly secure; you
        should submit information only if you accept this residual risk.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">8. Governing law</h2>
      <p>This policy is governed by the laws of the Federal Republic of Somalia.</p>
    </LegalShell>
  );
}
